import React from 'react';
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import EmailWalletButton from './EmailWalletButton';
import './ConnectWalletStepComponent.css';

// ConnectWalletStepComponent: just render the wallet button;
// page-step logic in MuultiPage decides which step to show.
export default function ConnectWalletStepComponent() {
    return (
        <div className="muulti-container connect-wallet-step" id="step-1-container">
            <WalletMultiButton />
            <EmailWalletButton compact />
        </div>
    );
}
